<!-- Refund Payment Methods Modal  -->
<p-dialog [visible]="showRefundModal()" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '550px'}" styleClass="no-header-modal">
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div class="sticky left-0 top-0 surface-0 p-3 flex align-items-center justify-content-between border-bottom-1 border-300 z-1">
      <h2 class="mb-0 text-sm font-bold">{{'REFUND.CHOOSE_PAYMENT_OPTION' | translate }} {{ refundData().amount | currencyformat}}</h2>
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopup(false)"></div>
    </div>
    <!-- Header -->
    <form [formGroup]="refundForm">
      <!-- Content -->

      <div class="surface-100 px-3 text-sm">
        <div class="p-3 border-top-1 border-400" [ngClass]="false ? 'pointer-events-none opacity-50 ng-tns-c274-9':''">
          <h5 class="text-sm flex align-items-center mb-2">
            <i class="fa fa-credit-card text-500 mr-3"></i>
            {{'POS.MEMBERSHIP_ADDON.CHOOSE_PAYMENT_METHOD' | translate}}
          </h5>
          <!-- Other Payment -->
          <div class="bg-blue-50 border-1 border-primary border-round mt-3">
            <div class="surface-0 border-1 border-300 border-round mx-3 my-3">
              <div class="p-3 border-bottom-1 border-300 text-sm">
                <div class="flex align-items-center">
                  <p-radioButton formControlName="otherPaymentMode" name="otherPaymentMode" inputId="credit" value="credit" />
                  <label for="credit" class="text-sm ml-2">{{'POS.MEMBERSHIP_ADDON.CREDITCARD' | translate}}</label>
                </div>

                @if (otherPaymentMethod === 'credit') {
                  <div class="mt-3 mx-4">
                    <div class="flex align-items-center">
                      <label for="cc-number" class="font-medium text-700 text-xs mr-2 block uppercase">xxxx-xxxx-xxxx-</label>
                      <!-- <p-inputMask id="cc-number" mask="9999" formControlName="frmCCNumber" [slotChar]="''" styleClass="text-sm w-6rem" type="tel"> </p-inputMask> -->
                      <p-inputNumber formControlName="frmCCNumber" styleClass="text-sm w-6rem"
                        [useGrouping]="false" [maxlength]="4" [max]="9999" />
                    </div>
                    <p-message severity="info" icon="fa fa-info-circle" aria-label="last-4-digits-info">
                      {{'POS.MEMBERSHIP_ADDON.LAST_4_DIGIT' | translate}}
                    </p-message>
                    @if (this.frmCC_NumberFormControl.touched && this.frmCC_NumberFormControl.invalid) {
                      <app-error-msg class="mb-3"
                        [errors]="this.frmCC_NumberFormControl.errors"
                        [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_CCCARD' | translate"
                         />
                    }
                    <input type="text" pInputText class="w-full text-sm mt-2" placeholder="{{'POS.MEMBERSHIP_ADDON.NETWORK_TYPE' | translate}}" formControlName="frmCCNetworkType" />
                    @if (this.frmCC_NetworkTypeFormControl.touched && this.frmCC_NetworkTypeFormControl.invalid) {
                      <app-error-msg class="mb-3"
                        [errors]="this.frmCC_NetworkTypeFormControl.errors"
                        [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_CCNETWORKTYPE' | translate"
                         />
                    }
                    <p-inputMask appNumberFormatInEnglish mask="99/9999" placeholder="mm/yyyy" formControlName="frmCCExpiryDate" styleClass="w-full text-sm mt-2" />
                    @if (this.frmCC_CardExpiryFormControl.touched && this.frmCC_CardExpiryFormControl.invalid) {
                      <app-error-msg class="mb-3"
                        [errors]="this.frmCC_CardExpiryFormControl.errors"
                        [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_CCEXPIRYDATE' | translate"
                         />
                    }
                    <!-- <p-inputNumber styleClass="w-full text-sm mt-2" inputStyleClass="px-1" formControlName="frmCCAuthCode" placeholder="{{'POS.MEMBERSHIP_ADDON.AUTH_CODE' | translate}}" [format]="false"> </p-inputNumber> -->
                    <input type="text" pInputText class="w-full text-sm mt-2" formControlName="frmCCAuthCode"  placeholder="{{'POS.MEMBERSHIP_ADDON.AUTH_CODE' | translate}}" />
                    @if (this.frmCC_AuthCodeFormControl.touched && this.frmCC_AuthCodeFormControl.invalid) {
                      <app-error-msg class="mb-3"
                        [errors]="this.frmCC_AuthCodeFormControl.errors"
                        [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_CCAUTHCARD' | translate"
                         />
                    }
                    <div class="mt-2 flex align-items-center">
                      <div class="p-inputgroup w-10rem mr-3 flex align-items-center">
                        <span class="p-inputgroup-addon text-sm flex align-items-center justify-content-center mr-1"> {{currencySymbol$ | async}} </span>
                        <!-- <p-inputNumber styleClass="w-full text-sm" inputStyleClass="px-1" formControlName="frmCCAmt" mode="decimal" [maxFractionDigits]="4" [placeholder]="'POS.MEMBERSHIP_ADDON.AMT' | translate">
                      </p-inputNumber> -->
                      <p-inputNumber formControlName="frmCCAmt" styleClass="w-full text-sm"
                        [placeholder]="'POS.MEMBERSHIP_ADDON.AMT' | translate" mode="decimal" [maxFractionDigits]="4" />
                    </div>
                    @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                      <div class="text-sm flex align-items-center" id="balance"
                        >
                        <span class="text-600 mr-2">{{'POS.MEMBERSHIP_ADDON.BALANCE' | translate}}</span>
                        @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                          <strong>
                            {{ totalOneTimeCost | currencyformat }}
                          </strong>
                        }
                      </div>
                    }
                  </div>
                  @if (frmCC_AmountFormControl.errors && frmCC_AmountFormControl.errors['max']) {
                    <div class="p-error text-xs mb-0 required">
                      @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                        <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_PAYMENT_VALUE_REFUND' | translate}}</span>
                      }
                      @if (refundData().refundType === getRefundType.CreditBalance || refundData().refundType.toString() === getRefundType[getRefundType.CreditBalance]) {
                        <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_CREDITBALANCE_VALUE_REFUND' | translate}}</span>
                      }
                    </div>
                  }
                  @if (frmCC_AmountFormControl.errors && frmCC_AmountFormControl.errors['min']) {
                    <div class="p-error text-xs mb-0 required">
                      @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                        <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_PAYMENT_VALUE_REFUND' | translate :{PaymentAmount:frmCC_AmountFormControl.value, TotalAmount: getRequiredAmount()} }}</span>
                      }
                      @if (refundData().refundType === getRefundType.CreditBalance || refundData().refundType.toString() === getRefundType[getRefundType.CreditBalance]) {
                        <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_CREDITBALANCE_VALUE_REFUND' | translate :{PaymentAmount:frmCC_AmountFormControl.value, TotalAmount: getRequiredAmount()} }}</span>
                      }
                    </div>
                  }
                </div>
              }
            </div>

            <div class="p-3 border-bottom-1 border-300">
              <div class="flex align-items-center">
                <p-radioButton formControlName="otherPaymentMode" name="otherPaymentMode" inputId="debit" value="debit" />
                <label for="debit" class="text-sm ml-2">{{'POS.MEMBERSHIP_ADDON.DEBITCARD' | translate}}</label>
              </div>
              @if (otherPaymentMethod === 'debit') {
                <div class="mt-3 mx-4">
                  <div class="flex align-items-center">
                    <label for="frmDCNumber" class="font-medium text-700 text-xs mr-2 block uppercase">xxxx-xxxx-xxxx-</label>
                    <!-- <p-inputMask id="cc-number" mask="9999" formControlName="frmDCNumber" [slotChar]="''" styleClass="text-sm w-6rem" type="tel"></p-inputMask> -->
                    <p-inputNumber formControlName="frmDCNumber" styleClass="text-sm w-6rem"
                      [useGrouping]="false" [maxlength]="4" [max]="9999" />
                  </div>
                  <p-message severity="info" icon="fa fa-info-circle" aria-label="last-4-digits-info">
                    {{'POS.MEMBERSHIP_ADDON.LAST_4_DIGIT' | translate}}
                  </p-message>
                  @if (this.frmDC_NumberFormControl.touched && this.frmDC_NumberFormControl.invalid) {
                    <app-error-msg class="mb-3"
                      [errors]="this.frmDC_NumberFormControl.errors"
                      [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_DCCARD' | translate"
                       />
                  }
                  <input type="text" pInputText class="w-full text-sm mt-2" placeholder="{{'POS.MEMBERSHIP_ADDON.NETWORK_TYPE' | translate}}" formControlName="frmDCNetworkType" />
                  @if (this.frmDC_NetworkTypeFormControl.touched && this.frmDC_NetworkTypeFormControl.invalid) {
                    <app-error-msg class="mb-3"
                      [errors]="this.frmDC_NetworkTypeFormControl.errors"
                      [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_DCNETWORKTYPE' | translate"
                       />
                  }
                  <p-inputMask appNumberFormatInEnglish mask="99/9999" placeholder="mm/YYYY" formControlName="frmDCExpiryDate" styleClass="w-full text-sm mt-2" />
                  @if (this.frmDC_CardExpiryFormControl.touched && this.frmDC_CardExpiryFormControl.invalid) {
                    <app-error-msg class="mb-3"
                      [errors]="this.frmDC_CardExpiryFormControl.errors"
                      [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_DCEXPIRYDATE' | translate"
                       />
                  }
                  <!-- <p-inputNumber styleClass="w-full text-sm mt-2" formControlName="frmDCAuthCode" placeholder="{{'POS.MEMBERSHIP_ADDON.AUTH_CODE' | translate}}" [format]="false"> </p-inputNumber> -->
                  <input type="text" pInputText class="w-full text-sm mt-2" formControlName="frmDCAuthCode"  placeholder="{{'POS.MEMBERSHIP_ADDON.AUTH_CODE' | translate}}" />
                  @if (this.frmDC_AuthCodeFormControl.touched && this.frmDC_AuthCodeFormControl.invalid) {
                    <app-error-msg class="mb-3"
                      [errors]="this.frmDC_AuthCodeFormControl.errors"
                      [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_DCAUTHCARD' | translate"
                       />
                  }
                  <div class="mt-2 flex align-items-center">
                    <div class="p-inputgroup w-10rem mr-3 flex align-items-center">
                      <span class="p-inputgroup-addon text-sm flex align-items-center justify-content-center mr-1"> {{currencySymbol$ | async}} </span>
                      <!-- <p-inputNumber styleClass="w-full text-sm" formControlName="frmDCAmt" mode="decimal" [maxFractionDigits]="4" placeholder="{{'POS.MEMBERSHIP_ADDON.AMT' | translate}}"> </p-inputNumber> -->
                      <p-inputNumber formControlName="frmDCAmt" styleClass="w-full text-sm"
                        [placeholder]="'POS.MEMBERSHIP_ADDON.AMT' | translate" mode="decimal" [maxFractionDigits]="4" />
                    </div>
                    @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                      <div class="text-sm flex align-items-center" id="balance"
                        >
                        <span class="text-600 mr-2">{{'POS.MEMBERSHIP_ADDON.BALANCE' |translate}}</span>
                        @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                          <strong>
                            {{ totalOneTimeCost | currencyformat }}
                          </strong>
                        }
                      </div>
                    }
                  </div>
                  @if (frmDC_AmountFormControl.errors && frmDC_AmountFormControl.errors['max']) {
                    <div class="p-error text-xs mb-0 required">
                      @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                        <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_PAYMENT_VALUE_REFUND' | translate}}</span>
                      }
                      @if (refundData().refundType === getRefundType.CreditBalance || refundData().refundType.toString() === getRefundType[getRefundType.CreditBalance]) {
                        <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_CREDITBALANCE_VALUE_REFUND' | translate}}</span>
                      }
                    </div>
                  }
                  @if (frmDC_AmountFormControl.errors && frmDC_AmountFormControl.errors['min']) {
                    <div class="required p-error text-xs mb-0">
                      @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                        <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_PAYMENT_VALUE_REFUND' | translate :{PaymentAmount:frmDC_AmountFormControl.value, TotalAmount: getRequiredAmount()} }}</span>
                      }
                      @if (refundData().refundType === getRefundType.CreditBalance || refundData().refundType.toString() === getRefundType[getRefundType.CreditBalance]) {
                        <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_CREDITBALANCE_VALUE_REFUND' | translate :{PaymentAmount:frmDC_AmountFormControl.value, TotalAmount: getRequiredAmount()} }}</span>
                      }
                    </div>
                  }
                </div>
              }
            </div>

            <div class="p-3 border-bottom-1 border-300">
              <div class="flex align-items-center">
                <p-radioButton name="otherPaymentMode" formControlName="otherPaymentMode" value="cash" inputId="cash" />
                <label for="cash" class="text-sm ml-2">{{'POS.MEMBERSHIP_ADDON.CASH' | translate}}</label>
              </div>
              @if (otherPaymentMethod === 'cash') {
                <div class="mt-3 mx-4">
                  <div class="flex align-items-center">
                    <div class="p-inputgroup w-10rem mr-3 flex align-items-center">
                      <span class="p-inputgroup-addon text-sm flex align-items-center justify-content-center">
                        {{currencySymbol$ | async}}
                      </span>
                      <!-- <p-inputNumber styleClass="w-full text-sm" formControlName="frmCashAmount" mode="decimal" [maxFractionDigits]="4" placeholder="{{'POS.MEMBERSHIP_ADDON.AMT' | translate}}"> </p-inputNumber> -->
                      <p-inputNumber formControlName="frmCashAmount" styleClass="w-full text-sm"
                        [placeholder]="'POS.MEMBERSHIP_ADDON.AMT' | translate" mode="decimal" [maxFractionDigits]="4" />
                    </div>
                    @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                      <div class="text-sm flex align-items-center">
                        <span class="text-600 mr-2">{{'POS.MEMBERSHIP_ADDON.BALANCE' | translate}}</span>
                        @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                          <strong>
                            {{ totalOneTimeCost | currencyformat }}
                          </strong>
                        }
                      </div>
                    }
                  </div>
                  @if (frmCash_AmountFormControl.errors && frmCash_AmountFormControl.errors['max']) {
                    <div class="p-error text-xs mb-0 required">
                      @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                        <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_PAYMENT_VALUE_REFUND' | translate}}</span>
                      }
                      @if (refundData().refundType === getRefundType.CreditBalance || refundData().refundType.toString() === getRefundType[getRefundType.CreditBalance]) {
                        <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_CREDITBALANCE_VALUE_REFUND' | translate}}</span>
                      }
                    </div>
                  }
                  @if (frmCash_AmountFormControl.errors && frmCash_AmountFormControl.errors['min']) {
                    <div class="p-error text-xs mb-0 required">
                      @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                        <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_PAYMENT_VALUE_REFUND' | translate :{PaymentAmount:frmCash_AmountFormControl.value, TotalAmount: getRequiredAmount()} }}</span>
                      }
                      @if (refundData().refundType === getRefundType.CreditBalance || refundData().refundType.toString() === getRefundType[getRefundType.CreditBalance]) {
                        <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_CREDITBALANCE_VALUE_REFUND' | translate :{PaymentAmount:frmCash_AmountFormControl.value, TotalAmount: getRequiredAmount()} }}</span>
                      }
                    </div>
                  }
                </div>
              }
            </div>

            <div class="p-3 border-bottom-1 border-300">
              <div class="flex align-items-center">
                <p-radioButton name="otherPaymentMode" formControlName="otherPaymentMode" inputId="cheque" value="cheque"  />
                <label for="cheque" class="text-sm ml-2">{{'POS.MEMBERSHIP_ADDON.CHEQUE' | translate}}</label>
              </div>
              @if (otherPaymentMethod === 'cheque') {
                <div class="mt-3 mx-4">
                  <input pInputText formControlName="frmChequeBankName" class="w-full text-sm mt-2" placeholder="{{'POS.MEMBERSHIP_ADDON.BANK_NAME' | translate}}" />
                  @if (this.frmCheque_BankNameFormControl.touched && frmCheque_BankNameFormControl.invalid) {
                    <app-error-msg class="mb-3"
                      [errors]="this.frmCheque_BankNameFormControl.errors"
                      [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_CHEQUEBANKNAME' | translate"
                       />
                  }
                  <p-datepicker [showIcon]="true" formControlName="frmChequeDate" [readonlyInput]="true" placeholder="{{'POS.MEMBERSHIP_ADDON.Cheque_Date' | translate}}" styleClass="w-full text-sm mt-2" />
                  @if (this.frmCheque_DateFormControl.touched && frmCheque_DateFormControl.invalid) {
                    <app-error-msg class="mb-3"
                      [errors]="this.frmCheque_DateFormControl.errors"
                      [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_CHEQUEDATE' | translate"
                       />
                  }
                  <div class="mt-2 flex align-items-center">
                    <div class="p-inputgroup w-10rem mr-3 flex align-items-center">
                      <span class="p-inputgroup-addon text-sm flex align-items-center justify-content-center mr-1">
                        {{currencySymbol$ | async}}
                      </span>
                      <!-- <p-inputNumber styleClass="w-full text-sm" inputStyleClass="px-1" formControlName="frmChequeAmount" mode="decimal" [maxFractionDigits]="4" placeholder="{{'POS.MEMBERSHIP_ADDON.AMT' | translate}}">
                    </p-inputNumber> -->
                    <p-inputNumber formControlName="frmChequeAmount" styleClass="w-full text-sm"
                      [placeholder]="'POS.MEMBERSHIP_ADDON.AMT' | translate" mode="decimal" [maxFractionDigits]="4" />
                  </div>
                  @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                    <div class="text-sm flex align-items-center" id="balance"
                      >
                      <span class="text-600 mr-2">{{'POS.MEMBERSHIP_ADDON.BALANCE' | translate}}</span>
                      @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                        <strong>
                          {{ totalOneTimeCost | currencyformat }}
                        </strong>
                      }
                    </div>
                  }
                </div>
                @if (frmCheque_AmountFormControl.errors && frmCheque_AmountFormControl.errors['max']) {
                  <div class="p-error text-xs mb-0 required">
                    @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                      <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_PAYMENT_VALUE_REFUND' | translate}}</span>
                    }
                    @if (refundData().refundType === getRefundType.CreditBalance || refundData().refundType.toString() === getRefundType[getRefundType.CreditBalance]) {
                      <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_CREDITBALANCE_VALUE_REFUND' | translate}}</span>
                    }
                  </div>
                }
                @if (frmCheque_AmountFormControl.errors && frmCheque_AmountFormControl.errors['min']) {
                  <div class="p-error text-xs mb-0 required">
                    @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                      <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_PAYMENT_VALUE_REFUND' | translate :{PaymentAmount:frmCheque_AmountFormControl.value, TotalAmount: getRequiredAmount()} }}</span>
                    }
                    @if (refundData().refundType === getRefundType.CreditBalance || refundData().refundType.toString() === getRefundType[getRefundType.CreditBalance]) {
                      <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_CREDITBALANCE_VALUE_REFUND' | translate :{PaymentAmount:frmCheque_AmountFormControl.value, TotalAmount: getRequiredAmount()} }}</span>
                    }
                  </div>
                }
              </div>
            }
          </div>

          <div class="p-3 border-bottom-1 border-300">
            <div class="flex align-items-center">
              <p-radioButton name="otherPaymentMode" formControlName="otherPaymentMode" value="upi" inputId="upi"  />
              <label for="upi" class="text-sm ml-2">{{'POS.MEMBERSHIP_ADDON.UPI' | translate}}</label>
            </div>
            @if (otherPaymentMethod === 'upi') {
              <div class="mt-3 mx-4">
                <input pInputText formControlName="frmUpiProvider" class="w-full text-sm mt-2" placeholder="{{'POS.MEMBERSHIP_ADDON.UPI_PROVIDER' | translate}}" />
                @if (this.frmUpiProviderFormControl.touched && this.frmUpiProviderFormControl.invalid) {
                  <app-error-msg class="mb-3"
                    [errors]="this.frmUpiProviderFormControl.errors"
                    [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_UPIID' | translate"
                     />
                }
                <input pInputText formControlName="frmUpiVpaid" class="w-full text-sm mt-2" placeholder="{{'POS.MEMBERSHIP_ADDON.UPI_VPA_ID' | translate}}" />
                @if (this.frmUpiVpaidFormControl.touched && this.frmUpiVpaidFormControl.invalid) {
                  <app-error-msg class="mb-3"
                    [errors]="this.frmUpiVpaidFormControl.errors"
                    [fieldLabel]="'POS.MEMBERSHIP_ADDON.FL_VPAID' | translate"
                     />
                }
                <div class="mt-2 flex align-items-center">
                  <div class="p-inputgroup w-10rem mr-3 flex align-items-center">
                    <span class="p-inputgroup-addon text-sm flex align-items-center justify-content-center mr-1">
                      {{currencySymbol$ | async}}
                    </span>
                    <!-- <p-inputNumber styleClass="w-full text-sm" inputStyleClass="px-1" formControlName="frmUpiAmount" mode="decimal" [maxFractionDigits]="4" placeholder="{{'POS.MEMBERSHIP_ADDON.AMT' | translate}}">
                  </p-inputNumber> -->
                  <p-inputNumber formControlName="frmUpiAmount" styleClass="w-full text-sm"
                    [placeholder]="'POS.MEMBERSHIP_ADDON.AMT' | translate" mode="decimal" [maxFractionDigits]="4" />
                </div>
                @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                  <div class="text-sm flex align-items-center" id="balance"
                    >
                    <span class="text-600 mr-2">{{'POS.MEMBERSHIP_ADDON.BALANCE' | translate}}</span>
                    @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                      <strong>
                        {{ totalOneTimeCost | currencyformat }}
                      </strong>
                    }
                  </div>
                }
              </div>
              @if (frmUpiVpaidFormControl.errors && frmUpiVpaidFormControl.errors['max']) {
                <div class="p-error text-xs mb-0 required">
                  @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                    <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_PAYMENT_VALUE_REFUND' | translate}}</span>
                  }
                  @if (refundData().refundType === getRefundType.CreditBalance || refundData().refundType.toString() === getRefundType[getRefundType.CreditBalance]) {
                    <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_CREDITBALANCE_VALUE_REFUND' | translate}}</span>
                  }
                </div>
              }
              @if (frmUpiVpaidFormControl.errors && frmUpiVpaidFormControl.errors['min']) {
                <div class="p-error text-xs mb-0 required">
                  @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                    <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_PAYMENT_VALUE_REFUND' | translate :{PaymentAmount:frmUpiVpaidFormControl.value, TotalAmount: getRequiredAmount()} }}</span>
                  }
                  @if (refundData().refundType === getRefundType.CreditBalance || refundData().refundType.toString() === getRefundType[getRefundType.CreditBalance]) {
                    <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_CREDITBALANCE_VALUE_REFUND' | translate :{PaymentAmount:frmUpiVpaidFormControl.value, TotalAmount: getRequiredAmount()} }}</span>
                  }
                </div>
              }
            </div>
          }
        </div>

        @if (refundData().isOnline) {
          <div class="p-3 bg-blue-100">
            <div class="flex align-items-center">
              <p-radioButton name="otherPaymentMode" formControlName="otherPaymentMode" inputId="online" value="online" />
              @if (PaymentMethodDetails) {
                <label for="online" class="ml-2">
                  <strong class="font-bold" >{{'REFUND.REFUND_BACK_TO_SOURCE' | translate : { payment_method: PaymentMethodDetails.number } }}</strong>
                </label>
              }
            </div>
            @if (otherPaymentMethod === 'online') {
              <div class="mt-3 mx-4">
                <div class="mt-2 flex align-items-center">
                  <div class="p-inputgroup w-10rem mr-3 flex align-items-center">
                    <span class="p-inputgroup-addon text-sm flex align-items-center justify-content-center mr-1">
                      {{currencySymbol$ | async}}
                    </span>
                    <!-- <p-inputNumber styleClass="w-full text-sm" inputStyleClass="px-1" formControlName="frmUpiAmount" mode="decimal" [maxFractionDigits]="4" placeholder="{{'POS.MEMBERSHIP_ADDON.AMT' | translate}}">
                  </p-inputNumber> -->
                  <p-inputNumber formControlName="frmOnlineAmount" styleClass="w-full text-sm"
                    [placeholder]="'POS.MEMBERSHIP_ADDON.AMT' | translate" mode="decimal" [maxFractionDigits]="4" />
                </div>
                @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                  <div class="text-sm flex align-items-center" id="balance"
                    >
                    <span class="text-600 mr-2">{{'POS.MEMBERSHIP_ADDON.BALANCE' | translate}}</span>
                    @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                      <strong>
                        {{ totalOneTimeCost | currencyformat }}
                      </strong>
                    }
                  </div>
                }
              </div>
              @if (frmOnlineAmountFormControl.errors && frmOnlineAmountFormControl.errors['max']) {
                <div class="p-error text-xs mb-0 required">
                  @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                    <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_PAYMENT_VALUE_REFUND' | translate}}</span>
                  }
                  @if (refundData().refundType === getRefundType.CreditBalance || refundData().refundType.toString() === getRefundType[getRefundType.CreditBalance]) {
                    <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_CREDITBALANCE_VALUE_REFUND' | translate}}</span>
                  }
                </div>
              }
            </div>
          }
        </div>
      }

      @for (paymentMode1 of this.paymentModes$ | async; track paymentMode1; let n = $index) {
        <div class="p-3 border-bottom-1 border-300">
          <div class="flex align-items-center">
            <p-radioButton name="otherPaymentMode" formControlName="otherPaymentMode" value="{{'otherPaymentMode_rb_' + paymentMode1.id}}" inputId="{{'otherPaymentMode_rb_' + paymentMode1.id}}" />
            <label for="{{'otherPaymentMode_rb_' + paymentMode1.id}}" class="text-sm ml-2">{{paymentMode1.name_primary_language}}</label>
          </div>
          @if (otherPaymentMethod === 'otherPaymentMode_rb_' + paymentMode1.id) {
            <div class="mt-3 mx-4">
              @if (checkPaymentModeRequiresRefNumber(paymentMode1)) {
                <input
                  type="text"
                  pInputText
                  class="w-full text-sm mt-2"
                  [placeholder]="'POS.MEMBERSHIP_ADDON.REFERENCE_NUMBER' | translate"
                  formControlName="{{'inp_otherPaymentMode_refno' + paymentMode1.id}}"/>
              }
              @if (getFormControlByName('inp_otherPaymentMode_refno' + paymentMode1.id) && getFormControlByName('inp_otherPaymentMode_refno' + paymentMode1.id).touched && getFormControlByName('inp_otherPaymentMode_refno' + paymentMode1.id).invalid) {
                <app-error-msg class="mb-3"
                  [errors]="getFormControlByName('inp_otherPaymentMode_refno' + paymentMode1.id).errors"
                  [fieldLabel]="'POS.MEMBERSHIP_ADDON.REFERENCE_NUMBER' | translate" />
              }
              <div class="flex align-items-center mt-2">
                <div class="p-inputgroup w-10rem mr-3 flex align-items-center">
                  <span class="p-inputgroup-addon text-sm flex align-items-center justify-content-center mr-1">{{currencySymbol$ | async}}</span>
                  <!-- <p-inputNumber
                  styleClass="w-full text-sm"
                  formControlName="{{'inp_otherPaymentMode_' + paymentMode1.id}}"
                  mode="decimal"
                  [maxFractionDigits]="4"
                  placeholder="{{'POS.MEMBERSHIP_ADDON.AMT' | translate}}">
                </p-inputNumber> -->
                <p-inputNumber [formControlName]="'inp_otherPaymentMode_' + paymentMode1.id" styleClass="w-full text-sm"
                  [placeholder]="'POS.MEMBERSHIP_ADDON.AMT' | translate" mode="decimal" [maxFractionDigits]="4" />
              </div>
              @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                <div class="text-sm flex align-items-center"
                  >
                  <span class="text-600 mr-2">{{'POS.MEMBERSHIP_ADDON.BALANCE' |translate}}</span>
                  @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                    <strong>
                      {{ totalOneTimeCost | currencyformat }}
                    </strong>
                  }
                </div>
              }
            </div>
            @if (getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id)
              && getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id).errors
              && getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id).errors!['max']) {
              <div
                class="p-error text-xs mb-0 required"
                >
                @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                  <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_PAYMENT_VALUE_REFUND' | translate}}</span>
                }
                @if (refundData().refundType === getRefundType.CreditBalance || refundData().refundType.toString() === getRefundType[getRefundType.CreditBalance]) {
                  <span class="p-error mt-1 validationerror">{{'common.errors.validations.MAX_CREDITBALANCE_VALUE_REFUND' | translate}}</span>
                }
              </div>
            }
            @if (getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id)
              && getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id).errors
              && getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id).errors!['min']) {
              <div
                class="p-error text-xs mb-0 required"
                >
                @if (refundData().refundType === getRefundType.Payment || refundData().refundType.toString() === getRefundType[getRefundType.Payment]) {
                  <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_PAYMENT_VALUE_REFUND' | translate :{PaymentAmount:getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id).value, TotalAmount: getRequiredAmount()} }}</span>
                }
                @if (refundData().refundType === getRefundType.CreditBalance || refundData().refundType.toString() === getRefundType[getRefundType.CreditBalance]) {
                  <span class="p-error mt-1 validationerror">{{'common.errors.validations.MIN_CREDITBALANCE_VALUE_REFUND' | translate :{PaymentAmount:getFormControlByName('inp_otherPaymentMode_' + paymentMode1.id).value, TotalAmount: getRequiredAmount()} }}</span>
                }
              </div>
            }
          </div>
        }
      </div>
    }

  </div>
</div>
<!-- Other Payment -->
</div>
<!-- Content -->

<!-- Content -->
<div class="p-3 border-top-1 border-300">
  <div class="grid">
    <div class="col-12 md:col-6">
      <label for="reason" class="font-medium text-700 text-xs mb-2 block uppercase">{{'REFUND.REASON_FOR_RETURN' | translate}}</label>
      <p-select [options]="returnReasons" appendTo="body" formControlName="reason" optionLabel="value" styleClass="text-sm w-full" filterBy="name" [placeholder]="'SALES_RETURN.REASON_PLACEHOLDER' | translate">
        <ng-template pTemplate="selectedItem">
          @if (SalesReturnReasonFormControl.value) {
            <div class="flex align-items-center">
              <div class="text-sm">{{'SALES_RETURN.REASONS.'+SalesReturnReasonFormControl.value.value | translate}}</div>
            </div>
          }
        </ng-template>
        <ng-template let-returnReason pTemplate="item">
          <div class="text-sm">{{'SALES_RETURN.REASONS.'+returnReason.value | translate}}</div>
        </ng-template>
      </p-select>
      @if (SalesReturnReasonFormControl.dirty && SalesReturnReasonFormControl.invalid) {
        <app-error-msg styleClass="md:block"
          [errors]="SalesReturnReasonFormControl.errors"
          [fieldLabel]="'SALES_RETURN.MSG.REASON_REQUIRED' | translate"
           />
      }
    </div>
    <div class="col-12 md:col-6">
      <label for="salesRep" class="font-medium text-700 text-xs mb-2 block uppercase">{{'SALES_RETURN.SALES_REP' | translate}}</label>
      <staff-selector [formGroup]="refundForm" [controlName]="SalesRepFormControl" [canRepresetative]="isClientRepresentative" [claims]="claims$"
      [id]="_selectedstaff" [styleClass]="'w-full text-sm py-0 align-items-center'" />
      @if (SalesRepFormControl.dirty && SalesRepFormControl.invalid) {
        <app-error-msg styleClass="md:block" [errors]="SalesRepFormControl.errors" [fieldLabel]="'SALES_RETURN.SALES_REP' | translate" />
      }
    </div>
    <div class="col-12">
      <label for="comment" class="font-medium text-700 text-xs mb-2 block uppercase">{{'SALES_RETURN.COMMENTS' | translate}}</label>
      <input id="comment" type="text" class="text-sm w-full h-3rem" pInputText placeholder="Name" formControlName="comment" />
      @if (SalesReturnReasonCommentFormControl.dirty && SalesReturnReasonCommentFormControl.invalid) {
        <app-error-msg styleClass="md:block"
          [errors]="SalesReturnReasonCommentFormControl.errors"
          [fieldLabel]="'SALES_RETURN.LBL_COMMENTS' | translate"
           />
      }
    </div>
  </div>
</div>
<!-- Content -->
</div>

<!-- Footer -->
<div class="sticky left-0 bottom-0 surface-0 p-3 text-center border-top-1 border-300">
  <p-button [label]="'REFUND.PROCESS_PAYMENT_BTN' | translate : { amount : getPaymentAmount(), currency: currencySymbol$ | async }" styleClass="text-sm w-full font-bold"  (click)="ProcessRefund()"  [loading]="btnLoading | async" [disabled]="!refundForm.valid" />
</div>
<!-- Footer -->
</form>
</ng-template>
</p-dialog>
<!-- Refund Payment Methods Modal  -->

<!-- Refund Confirm Modal -->
<p-dialog [visible]="refundConfirmModal" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '670px'}" styleClass="no-header-modal">

  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">

    <!-- Content -->
    <div class="relative text-center p-5 md:px-7">

      <div class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
      (click)="refundConfirmModal = false"></div>

      <i class="fa-solid fa-triangle-exclamation p-error text-7xl"></i>

      <h4 class="text-base md:text-lg my-3 font-normal"><strong class="font-bold">{{'SALES_RETURN.ARE_YOU_SURE' | translate}}</strong> <br class="hidden md:block">
      @if (PaymentMethodDetails) {
        <div [innerHTML]="'SALES_RETURN.THIS_ACTION_CANNOT_BE_UNDONE' | translate : { amount: (getSalesReturnAmountTotal() | currencyformat ), payment_method: PaymentMethodDetails.number }"></div>
      }
    </h4>

    <div class="mt-5">
      <label for="refundConfirm" class="font-medium text-700 text-xs mb-3 block uppercase">{{'SALES_RETURN.PLEASE_TYPE_REFUND_TO_CONFIRM' | translate}}</label>
      <input id="refundConfirm" type="text" class="w-full text-sm" pInputText [formControl]="refundConfirmControl" placeholder="Type REFUND here">
      @if (refundConfirmControl.dirty && refundConfirmControl.invalid) {
        <small class="p-error block mt-2">
          {{'SALES_RETURN.PLEASE_TYPE_REFUND_TO_CONFIRM_ERROR' | translate}}
        </small>
      }
    </div>

  </div>
  <!-- Content -->

  <!-- Modal Footer -->
  <div class="flex align-items-center justify-content-between p-3 border-top-1 border-300">
    <p-button label="Cancel" styleClass="p-button-text text-sm" (click)="ProcessRefundConfirm(false)" />
    <p-button [label]="'SALES_RETURN.YES_REFUND' | translate : { amount: (getSalesReturnAmountTotal() | currencyformat ) }" styleClass="text-sm" [disabled]="!refundConfirmControl.valid" (click)="ProcessRefundConfirm(true)" [loading]="btnConfirmRefundLoading" />
  </div>
  <!-- Modal Footer -->

</ng-template>

</p-dialog>
<!-- Refund Confirm Modal -->
